// Carries the current hypothesis card from Intake → Builder → Backtest so the
// Reality Check verdict can be linked back to the idea that produced it.
// localStorage-backed (survives navigation within the SPA). No network.

import type { HypothesisCard } from '../../types/validation';

const KEY = 'tradeatory.validation.currentHypothesis';

export function setCurrentHypothesis(card: HypothesisCard | null): void {
  try {
    if (card) localStorage.setItem(KEY, JSON.stringify(card));
    else localStorage.removeItem(KEY);
  } catch { /* ignore */ }
}

export function getCurrentHypothesis(): HypothesisCard | null {
  try {
    const s = localStorage.getItem(KEY);
    return s ? (JSON.parse(s) as HypothesisCard) : null;
  } catch {
    return null;
  }
}
